import { render, staticRenderFns } from "./PergolaDamageType.vue?vue&type=template&id=35546fde&scoped=true"
import script from "./PergolaDamageType.vue?vue&type=script&lang=ts"
export * from "./PergolaDamageType.vue?vue&type=script&lang=ts"
import style0 from "./PergolaDamageType.vue?vue&type=style&index=0&id=35546fde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35546fde",
  null
  
)

export default component.exports